/*

global
coreUtils
editorialSection
$
jQuery
*/

import { coreUtils } from "../../../assets/scripts/core-utils";

const coreEditorialSection = (($) => { // eslint-disable-line

	const me = {};
/*
	const initEditorialVideo = function() {

		const $playButton 		= $(this).siblings();
		const $videoContainer 	= $(this).parent();
		const youtubeId 		= $(this).parent().data().youtubeid;

		$playButton.addClass('hidden');
		$(this).addClass('hidden');
		$videoContainer.prepend('<iframe src="https://www.youtube.com/embed/' + youtubeId + '?rel=0&autohide=1&autoplay=1&showinfo=0" frameborder="0"></iframe>');

	}; */

	me.init = function() {

		coreUtils.initYoutubeVideo($('.js-video .video-thumbnail, .js-video .video-icon'));

	};

	return me;

})(jQuery);

export { coreEditorialSection };
